import * as React from "react";

function SvgDown(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        d="M16 3.696a.49.49 0 01-.127.334l-6.966 7.948a1.185 1.185 0 01-1.813 0L.127 4.03a.503.503 0 01.04-.708.505.505 0 01.707.047l6.973 7.948a.187.187 0 00.307 0l6.973-7.948a.505.505 0 01.706-.047.519.519 0 01.167.374z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgDown;
